const updates = [
  { date: '2026-07-29', title: '《秘密恋爱笔记》第128话更新', tag: '最新' },
  { date: '2026-07-29', title: '《剑与魔法纪元》第95话同步上线', tag: '同步' },
  { date: '2026-07-28', title: '新作《星海迷途》正式登陆本平台', tag: '新作' },
  { date: '2026-07-28', title: '《暗夜追踪者》第三季重磅回归', tag: '热门' },
  { date: '2026-07-27', title: '《咖啡馆的午后》第56话催泪更新', tag: '推荐' },
  { date: '2026-07-27', title: '《花都王朝》番外篇独家首发', tag: '独家' },
  { date: '2026-07-26', title: '暑期韩漫阅读活动正式开启', tag: '活动' },
  { date: '2026-07-26', title: '《爆笑学园日常》第200话纪念特辑', tag: '里程碑' },
  { date: '2026-07-25', title: '《灵界事务所》动画化决定公布', tag: '重磅' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          更新快讯
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          每日同步韩网更新，不错过任何精彩章节
        </p>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14">
                <div className="absolute left-[13px] md:left-[21px] top-2 w-2 h-2 rounded-full bg-primary-500 ring-4 ring-background-100"></div>

                <span className="text-xs text-foreground-400 whitespace-nowrap mt-0.5 min-w-[75px]">
                  {item.date}
                </span>

                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-800 leading-relaxed">
                    {item.title}
                  </p>
                </div>

                <span className={`shrink-0 px-2 py-0.5 text-xs font-medium rounded whitespace-nowrap ${
                  item.tag === '最新' || item.tag === '重磅'
                    ? 'bg-primary-100 text-primary-700'
                    : item.tag === '独家' || item.tag === '新作'
                    ? 'bg-accent-100 text-accent-800'
                    : item.tag === '活动'
                    ? 'bg-secondary-100 text-secondary-800'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.tag}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}